import { REPORT_RUNS } from '@src/graphql/queries/reportRun';
// eslint-disable-next-line report/no-extraneous-dependencies
import { usePaginatedFetchItems } from 'pe-core-frontend';
export const useReportRuns = ({ clientId }) => {
    const { page, setPage, pageSize, setPageSize, orderBy, setOrderBy, orderByDir, setOrderByDir, total, items: reportRuns, loading, error, find, } = usePaginatedFetchItems({
        spec: { clientId },
        fetchQuery: REPORT_RUNS,
        dataProp: 'reportRuns',
        initialPageSize: 10,
    });
    return {
        reportRuns,
        loading,
        page,
        pageSize,
        setPage,
        setPageSize,
        orderBy,
        setOrderBy,
        orderByDir,
        setOrderByDir,
        error,
        total,
        find,
    };
};
